import { ControlledSelect } from 'components/shared/ControlledFields';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { getCostCenterDutyHourTypeList } from '../hooks/getCostCenterDutyHourTypeList';

export const FormContent = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'importAbsenceSettings'
  });

  const importTypeOpts = [
    {
      value: 'SDB',
      label: 'SDB'
    },
    {
      value: 'AFAS',
      label: 'AFAS'
    }
  ];
  const dutyHourTypeOpts = getCostCenterDutyHourTypeList()?.map((item) => ({
    value: item.id,
    label: item.description
  }));

  const { control } = useFormContext();
  return (
    <>
      <ControlledSelect
        options={importTypeOpts}
        name="import_absence_type"
        label={t('importType')}
        control={control}
      />
      <ControlledSelect
        name="import_absence_dutyHourTypeId"
        control={control}
        label={t('dutyHourType')}
        options={dutyHourTypeOpts ?? []}
      />
      <ControlledSelect
        name="import_absence_dutyHourTypeIdPregnancy"
        label={t('pregnancyDutyHourType')}
        control={control}
        options={dutyHourTypeOpts ?? []}
      />
    </>
  );
};
